module.exports = __webpack_public_path__ + "img/Flatbed (1).972bed98.jpg";